import { EnvironmentProviders, inject, provideAppInitializer } from "@angular/core";
import { CookieStorageService } from "src/app/shared/services/cookie-storage.service";

/** Stores the campaign code included on the queryString during the app initialization */
export function searchAndSaveCampaignCodeOnAppInit(): EnvironmentProviders {
  return provideAppInitializer((): void => {
    const campaignCode: string | null = new URL(window.location.href).searchParams.get("campaign");
    if (campaignCode && campaignCode !== "null" && campaignCode !== "undefined") {
      inject(CookieStorageService).saveOrUpdateCampaignCode(campaignCode);
    }
  });
}
